// Facebook Pixel utility functions

// Initialize Facebook Pixel
export const initFacebookPixel = () => {
  const pixelId = import.meta.env?.VITE_FACEBOOK_PIXEL_ID;
  
  if (!pixelId || pixelId === 'your-facebook-pixel-id-here') {
    console.warn('Facebook Pixel ID not configured');
    return;
  }

  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('init', pixelId);
    window.fbq('track', 'PageView');
  }
};

// Track custom events
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

// Track standard events
export const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

export const trackViewContent = (contentName, contentCategory) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', {
      content_name: contentName,
      content_category: contentCategory
    });
  }
};

// Get Facebook Click ID from URL
export const getFbclid = () => {
  if (typeof window === 'undefined') return null;
  
  const urlParams = new URLSearchParams(window.location.search);
  const fbclid = urlParams?.get('fbclid');
  
  // Store in sessionStorage for persistence across pages
  if (fbclid) {
    sessionStorage.setItem('fbclid', fbclid);
    return fbclid;
  }
  
  // Retrieve from storage if not in URL
  return sessionStorage.getItem('fbclid');
};

// Add fbclid to external URL
export const addFbclidToUrl = (url) => {
  const fbclid = getFbclid();
  
  if (!fbclid) return url;
  
  try {
    const urlObj = new URL(url);
    urlObj?.searchParams?.set('fbclid', fbclid);
    return urlObj?.toString();
  } catch (e) {
    console.error('Invalid URL:', e);
    return url;
  }
};